import React, { useState, useEffect, useMemo } from "react"
import { checkIsSp } from "utils/util"

const useLandScape = () => {
  const [visible, setVisible] = useState(
    Math.abs(window.orientation as number) === 90
  )
  const landScape = () => {
    if (Math.abs(window.orientation as number) === 90) {
      setVisible(true)
    } else {
      setVisible(false)
    }
  }
  const addLandScape = () => {
    window.addEventListener("orientationchange", landScape)
  }

  useEffect(() => {
    addLandScape()
    return () => {
      window.removeEventListener("orientationchange", landScape, false)
    }
  }, [])
  return visible
}

const LandScape = () => {
  const visible = useLandScape()
  const isPhone = useMemo(() => {
    return checkIsSp()
  }, [])
  return (
    <>
      {visible && isPhone && (
        <div className="land-scape-wrapper">
          <i className="material-icons land-scape-items">screen_rotation</i>
          <p className="land-scape-items">横画面ではご利用できません</p>
          <p className="land-scape-items">ご了承ください</p>
        </div>
      )}
    </>
  )
}

export default LandScape
